import React from 'react';
import Footer from './Footer';


// Import all 20 images
import gal1 from '../img/gal1 (1).jpeg';
import gal2 from '../img/gal1 (2).jpeg';
import gal3 from '../img/gal1 (3).jpeg';
import gal4 from '../img/gal1 (4).jpeg';
import gal5 from '../img/gal1 (5).jpeg';
import gal6 from '../img/gal1 (6).jpeg';
import gal7 from '../img/gal1 (7).jpeg';
import gal8 from '../img/gal1 (8).jpeg';
import gal9 from '../img/gal1 (9).jpeg';
import gal10 from '../img/gal1 (10).jpeg';
import gal11 from '../img/gal1 (11).jpeg';
import gal12 from '../img/gal1 (12).jpeg';
import gal13 from '../img/gal1 (13).jpeg';
import gal14 from '../img/gal1 (14).jpeg';
import gal15 from '../img/gal1 (15).jpeg';
import gal16 from '../img/gal1 (16).jpeg';
import gal17 from '../img/gal1 (17).jpeg';
import gal18 from '../img/gal1 (18).jpeg';
import gal19 from '../img/gal1 (19).jpeg';
import gal20 from '../img/gal1 (20).jpeg';
import gal21 from '../img/gal21.jpg';
import gal22 from '../img/gal22.jpg';




const Photoes = () => {
  // Array of all imported images
  const images = [
    gal1, gal2, gal3, gal7, gal8, gal14, gal15, gal16, gal17, gal18, gal19, gal20, gal4, gal5, gal6,  gal9, gal10,
    gal11, gal12, gal13, gal21, gal22


    
  ];

  return (
    <>
      <div className="text-center my-4">
        <h1>Photos</h1>
      </div>

      <div className="container">
        <div className="row">
          {images.map((img, index) => (
            <div className="col-6 col-md-4 col-lg-3 mb-4" key={index}>
              <img src={img} alt={`Gallery ${index + 1}`} className="img-fluid rounded shadow" />
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Photoes;
